import graphql from "babel-plugin-relay/macro";
import { useEffect } from "react";
import { PreloadedQuery, usePreloadedQuery } from "react-relay";

import { getServerTimeOffsetMs } from "../../../../Common/utils/serverTimeOffset";
import { TimeSlotListInternalServerTimeQuery } from "./__generated__/TimeSlotListInternalServerTimeQuery.graphql";

export const TimeSlotListInternalServerTime = ({
  queryRef,
  onServerTimeOffsetLoaded,
}: {
  queryRef: PreloadedQuery<TimeSlotListInternalServerTimeQuery>;
  onServerTimeOffsetLoaded: (serverTimeOffsetMs: number | null) => void;
}) => {
  const data = usePreloadedQuery(
    TimeSlotListInternalServerTimeQueryString,
    queryRef
  );

  useEffect(() => {
    onServerTimeOffsetLoaded(getServerTimeOffsetMs(data.currentServerTime));
  }, [data.currentServerTime, onServerTimeOffsetLoaded]);

  return null;
};

export const TimeSlotListInternalServerTimeQueryString = graphql`
  query TimeSlotListInternalServerTimeQuery {
    currentServerTime
  }
`;
